/* eslint-disable jsx-a11y/anchor-is-valid */
import { h } from 'preact'
import RCPagination from 'rc-pagination'
import enUsLocale from 'rc-pagination/lib/locale/en_US'
import translate from 'core/hooks/useResource'
import { useSize } from 'utils/dom'

export default function Paging({
    className,
    pageNumber,
    pageSize,
    totalItems,
    onChange,
    ...rest
}) {
    const { isDesktop: desktop } = useSize()

    const locale = {
        // Options
        items_per_page: translate('pager.itemsPerPage'),
        jump_to: translate('pager.jumpTo'),
        jump_to_confirm: translate('pager.jumpToConfirm'),
        page: translate('pager.page'),

        // Pagination.jsx
        next_page: translate('pager.next'),
        prev_page: translate('pager.prev'),
        next_3: translate('pager.next.3'),
        prev_3: translate('pager.prev.3'),
        next_5: translate('pager.next.5'),
        prev_5: translate('pager.prev.5'),
        page_size: translate('pager.pageSize'),
    }

    const itemRender = (current, type, element) => {
        if (type === 'page') {
            return <button type="button" aria-label={locale.page}>{current}</button>
        }

        if (type === 'prev') {
            return <button type="button" aria-label={locale.prev_page}>{desktop ? locale.prev_page : '<'}</button>
        }

        if (type === 'next') {
            return <button type="button" aria-label={locale.next_page}>{desktop ? locale.next_page : '>'}</button>
        }

        if (type === 'jump-prev') {
            return <button type="button" aria-label={locale.prev_3}>{desktop ? locale.prev_3 : '<<'}</button>
        }

        if (type === 'jump-next') {
            return <button type="button" aria-label={locale.next_3}>{desktop ? locale.next_3 : '>>'}</button>
        }

        return element
    }

    return (
        <div className="pager">
            <RCPagination
                current={pageNumber}
                onChange={onChange}
                pageSize={pageSize}
                total={totalItems}
                className={className}
                locale={locale}
                itemRender={itemRender}
                showLessItems
                {...rest}
            />
        </div>
    )
}